import React from 'react';
import PropTypes from 'prop-types';

// Mixins / Modules
import { isEmptyObject } from '../../../../../../modules/global';
import { isSignedIn } from '../../../../../../modules/user';
import isResizable from '../../../../../mixins/resizable';

// Models
import EngagementModel from '../../../../../../models/v2/engagement';
import PersonaType from '../../../../../../models/v2/persona_type';
import Title from '../../../../../../models/v2/title';
import TitleCategory from '../../../../../../models/v2/title_category';

// Base
import Card from '../../../../base/card';
import Col from '../../../../base/col';
import Placeholder from '../../../../base/placeholder';
import Row from '../../../../base/row';

// Related Components
import Engagement from './listing/engagement';

export class Listing extends React.Component {
  static propTypes = {
    opportunity: PropTypes.object.isRequired,
    isDesktop: PropTypes.bool.isRequired,
  }

  state = {
    loading: true,
    engagement: {},
    title: {},
    titleCategory: {},
  }

  async componentDidMount() {
    this.loadData();
  }

  loadData = async () => {
    const { opportunity } = this.props;
    let title = {};
    let titleCategory = {};
    if (opportunity.title_id) {
      title = await Title.find(opportunity.title_id);
      titleCategory = await TitleCategory.find(title.title_category_id);
    } else if (opportunity.persona_type_id) {
      title = await PersonaType.find(opportunity.persona_type_id);
      titleCategory = title.persona_type_category;
    }

    let engagements = [];
    if (isSignedIn()) {
      engagements = await EngagementModel
        .url(`/api/v2/opportunities/${opportunity.id}/engagements`)
        .perPage(1)
        .sort('id desc')
        .all(false);
    }

    this.setState({
      title,
      titleCategory,
      engagement: engagements[0] || {},
      loading: false,
    });
  }

  render() {
    const { opportunity, isDesktop } = this.props;
    const { loading, title, titleCategory, engagement } = this.state;
    const durationMonths = parseInt(opportunity.duration) > 0 ? opportunity.duration : 'TBD';
    const displayTitle = `${opportunity.title} (${opportunity.id})`;

    const url = !isEmptyObject(engagement) && !engagement.complete ?
      `/opportunities/${opportunity.id}/engagements/${engagement.id}` :
      `/c/opportunities/${opportunity.id}`;

    return(
      <Card
        color='dark'
        className='min-height-0 margin-bottom-10'
        useAvatar
        avatar={opportunity.avatar_url}
        isOrganization
        stacked
      >
        <Row noMargin className='ellipsis'>
          <Col s={12} m={8}>
            <Row noMargin>
              <Col s={12}>
                <span className='title ellipsis' title={displayTitle}>
                  {
                    loading &&
                    <span className='primary-color'>
                      {displayTitle}
                    </span>
                  }
                  {
                    !loading &&
                    <a
                      href={url}
                      className='primary-color'
                    >{displayTitle}</a>
                  }
                </span>
              </Col>
              <Col s={12}>
                {opportunity.location}
              </Col>
              <Col s={12} className='caption'>
                {
                  (opportunity.is_closed && !isDesktop) &&
                  <div className='danger'>
                    <strong>CLOSED</strong>
                  </div>
                }
                <Row nested noMargin className='gray-900'>
                  <Col s={12}>
                    {
                      loading &&
                      <Placeholder lines={1} />
                    }
                    {
                      !loading &&
                      <React.Fragment>
                        {titleCategory.name}
                        &nbsp;&bull;&nbsp;
                        {title.name}
                      </React.Fragment>
                    }
                  </Col>
                  <Col s={12}>
                    Company Name: {opportunity.company_display_name}
                  </Col>
                  <Col s={12}>
                    Duration: {durationMonths} months
                  </Col>
                  {
                    !isDesktop &&
                    <Col s={12}>
                      <div className='margin-top-20'>
                        {
                          !loading &&
                          <Engagement
                            opportunity={opportunity}
                            engagement={engagement}
                          />
                        }
                      </div>
                    </Col>
                  }
                </Row>
              </Col>
            </Row>
          </Col>
          {
            isDesktop &&
            <Col m={4} className='hide-on-med-and-down caption right-align height-100pct'>
              {
                loading &&
                <Placeholder lines={1} />
              }
              {
                !loading && !opportunity.is_closed &&
                <Engagement
                  opportunity={opportunity}
                  engagement={engagement}
                />
              }
              {
                !loading && opportunity.is_closed &&
                <div className='right-align danger'>CLOSED</div>
              }
            </Col>
          }
        </Row>
      </Card>
    )
  }
}

export default isResizable(Listing);